import { render, staticRenderFns } from "./EnviarLinkMail.vue?vue&type=template&id=647c7cf7&scoped=true"
import script from "./EnviarLinkMail.vue?vue&type=script&lang=js"
export * from "./EnviarLinkMail.vue?vue&type=script&lang=js"
import style0 from "./EnviarLinkMail.vue?vue&type=style&index=0&id=647c7cf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c7cf7",
  null
  
)

export default component.exports